export const ROLE_GET_ALL = 'ROLE_GET_ALL'
export const ROLE_GET = 'ROLE_GET'
export const ROLE_DELETE = 'ROLE_DELETE'



// WEBPACK FOOTER //
// ./src/store/actions/roles.js